import React from "react";
import Header from "./Header";
import "../assets/styles/StartJourney.css";
import { TOEFL_PROGRAM_ID } from "../constants/Constants";

const StartJourney = ({ onContinue }) => {
  const programId = sessionStorage.getItem("program_id");
  return (
    <div
      style={{
        height: "100vh",
        backgroundColor: programId == TOEFL_PROGRAM_ID ? "#9196FF" : "#F4EAE6",
        flexDirection: "column",
        display: "flex",
      }}
    >
      <Header />
      <div style={{ flex: 1 }}>
        <div className="startpage-container">
          <h3>Start using the app</h3>
          <p>You will need your Identity document with you</p>
          <h4>How to verify your identity:</h4>
          <ul>
            <li>Make sure you have your identity document with you</li>
            <li>Take an image of your documents to capture your details</li>
            <li>
              Take a photo of yourself to check the document belongs to you
            </li>
          </ul>
        </div>
      </div>
      <div className="button-container">
        <button
          className={`continue-button ${
            programId === TOEFL_PROGRAM_ID ? "toefl-button-bg" : "gre-button-bg"
          } `}
          onClick={onContinue}
        >
          START
        </button>
      </div>
    </div>
  );
};

export default StartJourney;
